import { SendBirdChatChannel } from './sendbird-chat-channel';
import { TaskListItem } from './task-list-item';
import { WishListOrder } from './wish-list-order';

export class CollectingTaskListItem extends TaskListItem {
    public customerPhone: string;
    public calculatedPrice: number;
    public calculatedPriceEnabled: boolean;
    public pickingSeconds: number;
    public usePaperBag: boolean;
    public estimatedDeliveryStart: Date;
    public estimatedDeliveryEnd: Date;
    public wishListOrders: WishListOrder[];
    public sendBirdChatChannel?: SendBirdChatChannel;
}
